import { Component } from '@angular/core';
import { NavController, AlertController, ToastController, ModalController, LoadingController, ViewController, NavParams, DateTime } from 'ionic-angular';

import { SelectPage, LocationPage, AssignmentPage, ProjectPage, ClassificationPage } from '../';

import { Assignment, Api, User } from '@providers/asset/index';


@Component({
  selector: 'page-form_assignment',
  templateUrl: 'page.html'
})
export class FormAssignmentPage {

  val : any = [];
  data_user : any = [];

  item = {
    id               : '',
    assignor_id      : '',
    assignee_name    : '',
    assignee_id      : '',
    location_name    : '',
    location_id      : '',
    location_path_id : '',
    project_code     : '',
    project_title    : '',
    classification_name : '',
    classification_code : '',
    asset_name       : '',
    asset_id         : '',
    task             : '',
    task_date        : '',
    status           : ''
  }

  constructor(
    public navCtrl         : NavController,
    public toastCtrl       : ToastController,
    public loadingCtrl     : LoadingController,
    public viewCtrl        : ViewController,
    public alertCtrl       : AlertController,
    public modalCtrl       : ModalController,
    public navParams       : NavParams,
    public api             : Api,
    public assignmentApi   : Assignment,
    public userApi         : User
  ) {
    if(navParams.get('item')!=undefined){
      this.item = navParams.get('item');
      this.getVal(this.item.id);
    }
    this.data_user = JSON.parse(localStorage.data_user);

  }

  getVal(id){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = { id:id };
    
    this.assignmentApi.get(params).subscribe((resp:any) => {
      this.val = resp.data;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  pilihLocation(){
    let myModal = this.modalCtrl.create(LocationPage, {pilih:1});
    myModal.onDidDismiss(data => {
      if(data.item){
        this.item.location_name    = data.item.location_name;
        this.item.location_id      = data.item.id;
        this.item.location_path_id = data.item.location_path_id;
        this.item.project_title    = '';
        this.item.project_code     = '';
      }
      console.log("Location data => ",data);
    });
    myModal.present();
  }

  pilihClassification() {
    let myModal = this.modalCtrl.create(ClassificationPage, { pilih: 1 });
    myModal.onDidDismiss(data => {
      if(data.item){
        this.item.classification_name=data.item.classification_name;
        this.item.classification_code=data.item.classification_code;
      }
      console.log(data.item);
    });
    myModal.present();
  }

  pilihAsset(){
    let params : any = {
      pilihModal:1, selectMod:1, vList:1, assigne:0,
    }
    if(this.item.location_id != ''){
      params.asset_location_id = this.item.location_id,
      params.asset_location_path_id = this.item.location_path_id
    }
    if(this.item.project_code != ''){
      params.project_code = this.item.project_code
    }
    if(this.item.classification_code!=''){
      params.asset_classification_code = this.item.classification_code;
    }
    let myModal = this.modalCtrl.create(SelectPage, params);
    myModal.onDidDismiss(data => {
      if(data.item){
        this.item.asset_name = data.item.asset_name;
        this.item.asset_id = data.item.id;
      }
    });
    myModal.present();
  }
  
  pilihAssignee(){
    let myModal = this.modalCtrl.create(SelectPage, { pilihModal: 1, selectMod:2, vList:2, assigne:0 });
    myModal.onDidDismiss(data => {
      if(data.item){
        this.item.assignee_name = data.item.name;
        this.item.assignee_id   = data.item.Employee_ID;
      }
    });
    myModal.present();
  }

  pilihProject(){
    let myModal = this.modalCtrl.create(ProjectPage, { pilih:1 });
    myModal.onDidDismiss(data => {
      if(data.item){
        this.item.project_title = data.item.title;
        this.item.project_code  = data.item.project_code;
        this.item.location_name = '';
        this.item.location_id   = '';
      }
    });
    myModal.present();
  }
  
  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  save(){
            if(this.item.location_id=='' && this.item.project_code==''){
              this.presentToast("Please choose Asset Location / Project !");
              return;
            }
            else if(this.item.assignee_id==''){
              this.presentToast("Please choose Assignee !");
              return;
            }
            else if(this.item.task==''){
              this.presentToast("Please fill the Task field !");
              return;
            }
            
            let loading = this.loadingCtrl.create({
              content: 'Please wait...'
            });
            loading.present();
            let params = {
              id          :this.item.id,
              assignor_id :this.data_user.data.employee_id,
              assignee_id :this.item.assignee_id,
              location_id :this.item.location_id,
              project_code:this.item.project_code,
              asset_classification_code:this.item.classification_code,
              asset_id    :this.item.asset_id,
              task        :this.item.task
            };
            console.log(params);
              this.assignmentApi.save(params).subscribe((resp:any) => {      
                loading.dismiss();
              this.navCtrl.pop();
              }, (err) => {
                loading.dismiss();
              });

  }

}



// WEBPACK FOOTER //
// ./src/pages/asset/form_assignment/page.ts